/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing a product group.
 */
import equipmentService from '../../../../services/equipment';
import equipmentTransformer from '../../../../transformers/equipment';
import Forms from '../../../../utils/forms/forms';
import store from './../../../../store';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        isActive: {
          value: '',
          type: 'checkbox',
        },
      }),
      loading: false,
    };
  },

  created() {
    this.show();
  },


  methods: {
    /**
     * Method to update the product group.
     */
    update() {
      this.form.loading = true;
      const equipment = equipmentTransformer.send(this.form.data());
      equipmentService.update(store.state.route.params.id, equipment)
      .then(() => {
        this.form.loading = false;
        this.$message({
          message: this.$t('static.equipments.edit.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'production.equipments.index',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Fetches the product group object for editing.
     */
    show() {
      this.loading = true;
      equipmentService.show(store.state.route.params.id).then((equipment) => {
        this.form.assignData(equipment);
        this.loading = false;
      });
    },
  },

  watch: {
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/equipments/edit/edit.js